export default __webpack_public_path__ + "static/media/veqtor_conversacion.12ff97b4.svg";